 
export const parseDate = (input) => {
    if (!input) return ''; // Handle invalid input

    try {
        const datePart = input.substring(0, 8);
        const timePart = input.substring(9, 15);
        const millisecondsPart = input.substring(16);

        const year = datePart.substring(0, 4);
        const month = datePart.substring(4, 6);
        const day = datePart.substring(6, 8);

        const hours = timePart.substring(0, 2);
        const minutes = timePart.substring(2, 4);
        const seconds = timePart.substring(4, 6);

        // Create the Date object
        const date = new Date(year, month - 1, day, hours, minutes, seconds, millisecondsPart);

        // Format the date to a string
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            fractionalSecondDigits: 3
        };

        return date.toLocaleDateString('en-US', options);
    } catch (e) {
        return input; // Return the original input if parsing fails
    }
};
